import { render, staticRenderFns } from "./ComparatorTable.vue?vue&type=template&id=011edbe0&scoped=true&"
import script from "./ComparatorTable.vue?vue&type=script&lang=ts&"
export * from "./ComparatorTable.vue?vue&type=script&lang=ts&"
import style0 from "./ComparatorTable.vue?vue&type=style&index=0&id=011edbe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011edbe0",
  null
  
)

export default component.exports